import './less/main.less';
import './legacy';
import angular from 'angular';
import acme from './app/app';

async function bootstrapApp() {
  angular.element(document).ready(function () {
    angular.bootstrap(document, [acme], { strictDi: false });
  });
}

bootstrapApp();
